import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Language',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M12.5 21.5L10 24c-1.1 0-2-.9-2-2v-.5h4.5zm-6.2-15l-.6 2.7H7l-.5-2.7h-.2zM13.7 20H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h7.3c1 0 1.8.7 2 1.7L13.9 19c0 .3 0 .7-.2 1zm-4.5-7.4l-.5-2.7-.9-4.3c-.1-.4-.4-.6-.7-.6H5.6c-.3 0-.6.2-.7.6l-1.4 7c-.1.4.2.8.6.9h.1c.3 0 .7-.2.7-.6l.4-2.1h1.9l.4 2.1c.1.4.5.7.9.6.5-.1.8-.5.7-.9zm9.9 1.4c.5-.7.9-1.4 1.1-1.9H18c.2.5.5 1.1 1.1 1.9zM24 6v16c0 1.1-.9 2-2 2h-9.9l2.2-2.2c.8-.8 1.2-1.9 1-3L13.1 4H22c1.1 0 2 .9 2 2zm-1.4 5.3c0-.4-.3-.8-.8-.8h-2.1v-.6c0-.4-.3-.8-.8-.8s-.8.3-.8.8v.6H16c-.4 0-.8.3-.8.8s.3.8.8.8h.2c.2.7.7 1.8 1.6 3.1-.4.4-.9.8-1.6 1.2-.3.2-.4.7-.2 1 .1.2.4.3.6.3.1 0 .3 0 .4-.1.7-.4 1.3-.9 1.8-1.4.5.5 1.1.9 1.8 1.4.1.1.3.1.4.1.2 0 .5-.1.6-.3.2-.3.1-.8-.2-1-.6-.4-1.1-.8-1.6-1.2 1-1.2 1.4-2.4 1.6-3.1h.2c.7 0 1-.4 1-.8z" }
      })]
    );
  }
};